var map = {
	"./mobile/homeleft.png": "./src/components/LandingPages/images/tlyfe/mobile/homeleft.png",
	"./tab/homeleft.png": "./src/components/LandingPages/images/tlyfe/tab/homeleft.png",
	"./web/homeleft.png": "./src/components/LandingPages/images/tlyfe/web/homeleft.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/LandingPages/images/tlyfe sync recursive ^.*homeleft\\.png$";